import  { PROGRAM } from  './ActionTypes';
import api from '../api'

export function fetchPrograms(router, data) {
	return function (dispatch) {        
        api.get("programs").then(async (response) => {
            console.log("====programsresponse==="+JSON.stringify(response));
            if (response.status === "success") {
                await dispatch({
                    type: PROGRAM,
                    data: response.payload
                });
            }
        })
    }
}

export function addProgram(router, data) {
	return function (dispatch) {        
        api.post("programs", data).then(async (response) => {
            if (response.status === "success") {
                api.get("programs").then(async (response) => {
                  if (response.status === "success") {
                        await dispatch({
                            type: PROGRAM,
                            data: response.payload
                        });
                    }
                })
            }
        })
    }
}

export function updateProgram(program,id){
	return function(dispatch){
		api.put("programs/"+id, program).then(async (response) => {
            api.get("programs").then(async (response) => {
                if (response.status === "success") {
                      await dispatch({
                          type: PROGRAM,
                          data: response.payload
                      });
                  }
              })
		})
	}
}



